import styled from 'styled-components';
import { ThemeTagCard } from '../../../../Tags/ThemeTagCard';

export const Container = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.tertiary.main};
`;

export const Title = styled.div`
  display: flex;
  padding: 16px 16px 0 16px;
  font-size: 16px;
  font-weight: bold;
`;

export const ThemeTitle = styled(ThemeTagCard)`
  color: ${({ color }) => color};
  font-size: 16px;
`;

export const Count = styled.span`
  font-weight: normal;
  margin-left: 4px;
`;

export const Toggle = styled.button`
  display: block;
  box-sizing: border-box;
  padding: 0 16px 16px 16px;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.primary.main};
`;
